import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ColorCalendar = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.5 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.03516 2.15417V4.61232",
                stroke: "#6942F8",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.9648 2.15417V4.61232",
                stroke: "#6942F8",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.406 3.3833H6.59548C4.10654 3.3833 2.08887 5.40098 2.08887 7.88991V17.8018C2.08887 20.2907 4.10654 22.3084 6.59548 22.3084H17.406C19.895 22.3084 21.9127 20.2907 21.9127 17.8018V7.88991C21.9127 5.40098 19.895 3.3833 17.406 3.3833Z",
                fill: "#C3B3FC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.9639 10.3611H8.15332",
                stroke: "#6942F8",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.9991 15.3171H8.15332",
                stroke: "#6942F8",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
